var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAioaIconType12(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 132,
    viewBox: "0 0 132 132",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-1462 -430)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1462 430)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 10
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 66,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 66,
    cy: 66,
    r: 61,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(1497 456)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0.001)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M80.881,49.789,78.893,74.245c-.5,6.263-9.942,5.369-9.445-.8l1.591-18.989-6.363.3A24.2,24.2,0,0,1,60.6,81.9l-6.065-6.064c8.948-9.942,1.988-25.948-11.433-25.948a15.163,15.163,0,0,0-10.439,4.076L26.4,47.8a24.166,24.166,0,0,1,12.626-6.263L50.658,28.215,44.1,24.338,36.044,31.5c-4.673,4.176-10.936-2.883-6.263-7.059l10.538-9.445a4.662,4.662,0,0,1,5.468-.6S67.36,26.923,67.46,27.022a5.561,5.561,0,0,1,1.392,7.655,1.745,1.745,0,0,1-.4.5L59.308,45.514l16.5-.895a4.761,4.761,0,0,1,4.971,4.474,1.692,1.692,0,0,1,.1.7Z",
    transform: "translate(-18.844 -9.923)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.053,25.807A7.953,7.953,0,1,0,63.1,17.853,7.977,7.977,0,0,0,71.053,25.807Z",
    transform: "translate(-19.058 -9.9)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.959,81.122A15.551,15.551,0,0,1,27.449,65.513a15.074,15.074,0,0,1,2.684-8.649L23.97,50.7A23.563,23.563,0,0,0,18.8,65.513C18.8,85.794,42.163,96.73,57.772,84.5l-6.164-6.164A14.475,14.475,0,0,1,42.959,81.122Z",
    transform: "translate(-18.8 -10.138)",
    fill: "#fff"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAioaIconType12);
export default __webpack_public_path__ + "static/media/aioa-icon-type-12.bb5d5a076f8f63cb0a691ac1b1e7f031.svg";
export { ForwardRef as ReactComponent };